module.exports = __webpack_public_path__ + "img/award-in.0cb6f807.png";